
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/inlingua",
      function () {
        return require("private-next-pages/case-study/inlingua.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/inlingua"])
      });
    }
  